// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","304":"component---src-pages-terms-of-service-tsx","756":"component---src-pages-privacy-policy-tsx"}[chunkId] || chunkId) + "-" + {"245":"0ca915db8b5aea768138","304":"9b8515c4c82fe5e7e3dd","454":"0c6fbea3bfad50a22e81","756":"20b7f2ffbd7ab1d532b5"}[chunkId] + ".js";
};